import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAnimal from "common/hooks/useAnimal";
import AnimalForm from "./AnimalForm";

function Animal() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const { refreshAnimals } = useAnimal();

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "animals",
    id,
    {}
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/animals");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataAnimal: any) => {
      const newAnimal = { ...dataAnimal };

      try {
        if (newAnimal.id) {
          await updateItem(newAnimal.id, newAnimal);
        } else {
          await saveItem(newAnimal);
        }
      } catch (e: any) {
        return e;
      }
      refreshAnimals();
      back();
      return true;
    },
    [refreshAnimals, back, updateItem, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <AnimalForm onSubmit={onSubmit} animal={item} />
  );
}

export default Animal;
